import React, { useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  SelectChangeEvent,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { sortWords } from "../store/wordSlice";
import { AppDispatch } from "../store/store";
import { useLocation } from "react-router-dom";

interface SortSelectorProps {
  isDarkMode: boolean;
}

const SortSelector: React.FC<SortSelectorProps> = ({ isDarkMode }) => {
  const [sortOption, setSortOption] = useState("none");
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const isOnFavoritesPage = location.pathname === "/favorites";

  const handleSortChange = (event: SelectChangeEvent<string>) => {
    const selectedSort = event.target.value;
    setSortOption(selectedSort);

    dispatch(
      sortWords({ sortBy: selectedSort, isFavorite: isOnFavoritesPage })
    );
  };

  return (
    <FormControl
      sx={{
        mx: 2,
        minWidth: 120,
        "&::before": {
          display: "none",
        },
        "&::after": {
          display: "none",
        },
        "& .MuiInputBase-root": {
          "&::before, &::after": {
            display: "none",
          },
        },
      }}
    >
      <Select
        value={sortOption}
        onChange={handleSortChange}
        displayEmpty
        variant="standard"
        renderValue={(value) => (value === "none" ? "sort by" : value)}
        sx={{
          fontSize: "0.875rem",
          fontWeight: "500",
          borderRadius: "50px",
          backgroundColor: isDarkMode ? "#555" : "#f0f0f0",
          width: "200px",
          paddingLeft: "5px",
          height: "36px",
          display: "flex",
          alignItems: "center",
          "& .MuiSelect-select": {
            paddingLeft: "10px",
            fontFamily: "Ubuntu",
            color: "rgb(170, 170, 170)",
          },
        }}
      >
        <MenuItem value="none">none</MenuItem>
        <MenuItem value="alphabetical">alphabetical (a-z)</MenuItem>
        <MenuItem value="ascending">short to long</MenuItem>
      </Select>
    </FormControl>
  );
};

export default SortSelector;
